// extracted by mini-css-extract-plugin
export default {"link":"nav-link_link__8kpPG"};